export default "__VITE_ASSET__28c84b31__"